import React from 'react';

import { constants } from '@trqk/utils';

const { MAX_STATEMENT_SIZE_MB } = constants;

export const StatementTooLarge = (): JSX.Element => (
    <div style={{ width: 410 }} className="px-2">
        <p className="font-bold text-highlight-orange tracking-wider mb-2">
            Warning
        </p>
        <p className="mb-2">
            {`Trqk currently supports statements up to ${MAX_STATEMENT_SIZE_MB}MB in size.`}
        </p>
        <p className="mb-2">
            We are actively working to increase this size limit.
        </p>
    </div>
);
